import { ICategory } from 'api/types/_category';
import { INews, IPartner } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_INFO, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TableContainer from 'components/Common/TableContainer';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import { COLORS_STATUS_NEWS, KEYWORD_TYPE, KEY_GET_SOURCE, PUBLISH_NEWS_TYPE, SECTION_KEYWORD, STATUS_NEWS_OPTIONS } from 'helpers/constans';
import { filterMediaOptions, formatGetSource, formatNumberWithCommas } from 'helpers/format';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import ModalImportGenerateBoostingNewsV2 from 'pages/News/BoostingNews/ModalImportGenerateBoostingNewsV2';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { deleteMultiNewsV2, getAINewsByNormal, getAllCategory, getAllImageCategory, getAllPartners, putNews, getNewsWeatherWarnings as onGetNewsWeatherWarnings } from 'store/thunks';
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BoxFooterNews from '../../News/Components/BoxFooterNews';
import BoxGeneratedNews from '../../News/Components/BoxGeneratedNews';
import BoxImageSearch from '../../News/Components/BoxImageSearch';
import BoxSourceNews from '../../News/Components/BoxSourceNews';
import ButtonLanguage from '../../News/Components/ButtonLanguage';
import HighlightText from '../../News/Components/HighlightText';
import NestingFilter from '../../News/Components/NestingFilter';
import ModalPrompt from '../ModalPrompt';
interface Option {
    label: string;
    value: string;
}
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'created_at';

const ArticleList = (activeTab?: any) => {
    let document_w: any = window.document;
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const modalRef = useRef<any>(null);
    const modalBodyInnerRef = useRef<any>(null);

    const modalSourceInnerRefs = useRef<any>([]);

    const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 100),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        start_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        end_date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        keyword: withDefault(StringParam, ''),
        category_id: withDefault(StringParam, ''),
        media_id: withDefault(StringParam, ''),
        type: withDefault(StringParam, '2'),
    });

    const [listCategory, setListCategory] = useState<ICategory[]>([]);

    const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

    const [mediaSearch, setMediaSearch] = useState<Option | null>(!!query?.media_id ? { value: query?.media_id, label: '' } : null);

    const [categorySearch, setCategorySearch] = useState<Option | null>(!!query?.category_id ? { value: query?.category_id, label: '' } : null);


    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [newsDetail, setNewsDetail] = useState<INews | null>(null);

    const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
    const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<INews | null>(null);

    const [imageCategories, setImageCategories] = useState<any>([]);
    const [imageInsert, setImageInsert] = useState<any>(null);

    const [voteInsert, setVoteInsert] = useState<any>(null);

    const [partners, setPartners] = useState<IPartner[]>([]);

    const [isOpenModalNews, setIsOpenModalNews] = useState<boolean>(false);

    const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

    const [isOpenImportGenerateBoostingNewsV2, setIsOpenImportGenerateBoostingNewsV2] = useState<boolean>(false);

    const [queryModal, setQueryModal]: any = useState({
        time_request: 0,
        page: 1,
        limit: 500,
        sort_by: 'id',
        order_by: 'DESC',
        news_ids: '',
        section: `${SECTION_KEYWORD.BOOSTING}`,
        type_page_no_param: '',
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.News;

    const NewsProperties = createSelector(
        selectLayoutState,
        (state) => ({
            newsWeatherWarnings: state.newsWeatherWarnings,
            isNewsWeatherWarningSuccess: state.isNewsWeatherWarningSuccess,
            isNewsWeatherWarningLoading: state.isNewsWeatherWarningLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { newsWeatherWarnings, error, isNewsWeatherWarningLoading } = useSelector(NewsProperties);

    const onSetImageInsert = (item: any) => {
        setImageInsert((_prev: any) => item);
    }

    const onSetVoteKeywordInsert = (item: any) => {
        setVoteInsert((_prev: any) => item);
    }

    const handleQueryData = async () => {
        setIsListNewsLoading((prev) => true);
        const res: any = await getAINewsByNormal(queryModal);
        setListNews((prev: any) => ({
            list: res?.data?.list || [],
            total: res?.data?.pagination?.total || 0,
        }));
        setIsListNewsLoading((prev) => false);
        if (queryModal?.page === 1) {
            setNewsDetail((_prev) => (res?.data?.list?.find((_n: any) => String(_n?.id) === String(newsDetail?.id)) || res?.data?.list[0]));
        }

        if (!!newsDetail && queryModal?.type_page_no_param) {
            if (queryModal?.type_page_no_param === 'prev') {
                setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
                return;
            }
            if (queryModal?.type_page_no_param === 'next') {
                setNewsDetail((_prev) => res?.data?.list[0]);
                return;
            }
        }
    };

    const handleLoadMore = () => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: queryModal?.page + 1,
            type_page_no_param: 'next'
        }));
    }

    const handleLoadPrev = () => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: queryModal?.page - 1,
            type_page_no_param: 'prev'
        }));
    }


    useEffect(() => {
        dispatch(onGetNewsWeatherWarnings(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            keyword: keywordSearch || '',
            media_id: mediaSearch?.value || '',
            category_id: categorySearch?.value || '',
            type: '2',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            keyword: '',
            media_id: '',
            category_id: '',
            type: '2',
            start_date: `${moment().format("Y-MM-DD")}`,
            end_date: `${moment().format("Y-MM-DD")}`,
            sort_by: TYPE_SELECT_DEFAULT,
            order_by: 'DESC',
            page: 1,
            time_request: + new Date(),
        };

        setQuery(queryNew, "push");
        setKeywordSearch((_prev) => "");
        setMediaSearch((_prev) => null);
        setCategorySearch((_prev) => null);
        setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
    };

    useEffect(() => {
        if (!!queryModal?.news_ids) {
            handleQueryData();
        }
    }, [JSON.stringify(queryModal)]);

    const handleShowModalNews = (__news_ids: number[], __default_news_id: number | null = null) => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            news_ids: (__news_ids || [])?.join(','),
            type_page_no_param: '',
            page: 1
        }));
        if (!!__default_news_id) {
            setNewsDetail((_prev) => ({ ..._prev, id: __default_news_id } as INews));
        }
        setIsOpenModalNews((_prev) => true);
    };

    const handleCloseModalNews = () => {
        setIsOpenModalNews((_prev) => false);
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: 1,
            news_ids: '',
        }))
    };

    const handleSetNewsDetail = (detail: INews | null) => {
        setNewsDetail((_prev) => detail);
        if (!!detail && (window?.innerWidth <= 900) && (!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
            setTimeout(async () => {
                try {
                    if (modalRef.current && modalRef.current.requestFullscreen) {
                        await modalRef?.current?.requestFullscreen();
                    } else if (modalRef.current && modalRef.current.webkitRequestFullscreen) {
                        await modalRef?.current?.webkitRequestFullscreen(); // Safari
                    } else if (modalRef.current && modalRef.current.msRequestFullscreen) {
                        await modalRef?.current?.msRequestFullscreen(); // IE
                    }
                } catch (error) {
                    //console.error("Failed to enter fullscreen:", error);
                }
            }, 280);
        }
    };

    const onCloseClick = () => {
        handleCloseModalNews();
        setCurrentLang((_prev) => 'ko');
        handleSetNewsDetail(null);
        onSetImageInsert(null);
        onSetVoteKeywordInsert(null);
        setTypeShowInfoRight((_prev) => 'SOURCE');
        setListNews((prev: any) => ({
            list: [],
            total: 0,
        }));
    }

    const [typeShowInfoRight, setTypeShowInfoRight] = useState<'IMAGE' | 'SOURCE'>('SOURCE');
    const onShowInfoRightClick = () => {
        setTypeShowInfoRight((_prev) => (_prev === 'IMAGE' ? 'SOURCE' : 'IMAGE'));
    }

    const refContentNews = useRef<any>(null);
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const resetCursorToStart = () => {
        const editor = refContentNews?.current;
        if (editor) {
            // Find the first <br> tag or &nbsp; in the content after insertion
            const body = editor.getBody();
            const brNode = body.querySelector('br'); // Find the first <br> tag
            let targetNode = null;

            if (brNode) {
                targetNode = brNode; // Prioritize the <br> tag
            } else {
                // If no <br> is found, search for &nbsp; in text nodes
                const textNodes = Array.from(body.childNodes).filter(
                    (node: any) => node.nodeType === Node.TEXT_NODE && node.nodeValue?.includes('\u00A0')
                );
                if (textNodes.length > 0) {
                    targetNode = textNodes[0];
                }
            }

            if (targetNode) {
                // Place the cursor immediately after the <br> tag or &nbsp;
                const parentNode = targetNode.parentNode;
                const offset = Array.from(parentNode.childNodes).indexOf(targetNode) + 1;
                editor.selection.setCursorLocation(parentNode, offset);
            }

            // Update the bookmark state at the new cursor location
            const newBookmark = editor.selection.getBookmark();
            // editor?.selection.setCursorLocation(null, 0);
        }

    };

    const onSaveClick = async (is_show_noti_when_success: boolean = true) => {
        try {
            if (!newsDetail?.id) {
                return;
            }
            setIsSaving((_prev) => true);
            const response: any = await putNews(newsDetail?.id, {
                title: newsDetail?.title, // refContentNews?.current?.getTitle() || '' || 
                body: newsDetail?.body, // refContentNews?.current?.getContent() || '' || 
            });
            if (response?.code === 200) {
                setListNews((prev: any) => ({
                    list: (prev?.list || []).map((item: any) => {
                        if (String(item?.id) === String(newsDetail?.id)) {
                            return ({ ...item, ...response?.data })
                        }
                        return item;
                    }),
                    total: Number(prev?.total || 0),
                }));
                setNewsDetail((_prev: any) => ({ ..._prev, ...response?.data }));
                setIsSaving((_prev) => false);
                if (is_show_noti_when_success) {
                    toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                }
            } else {
                setIsSaving((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsSaving((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const scrollModalBodyToTop = () => {
        if (modalBodyInnerRef.current) {
            modalBodyInnerRef.current.scrollTo({ top: 0 });
        }
        if (modalSourceInnerRefs.current) {
            modalSourceInnerRefs.current.forEach((ref: any) => {
                if (ref) {
                    ref.scrollTo({ top: 0 });
                }
            });
        }
    };

    const handlePreviousNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsPrevious = Number(index_news_current) - 1;
            const newsPrevious = listNews?.list[indexNewsPrevious];
            if (!!newsPrevious) {
                handleSetNewsDetail({
                    ...(newsPrevious),
                    index: indexNewsPrevious,
                    disabled_prev: false,
                    disabled_next: false
                });
                scrollModalBodyToTop();
                setCurrentLang((_prev) => 'ko');
            }
            if (!newsPrevious) {
                if (Number(queryModal?.page) > 1) {
                    handleLoadPrev();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleNextNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsNext = Number(index_news_current) + 1;
            const newsNext = listNews?.list[indexNewsNext];
            if (!!newsNext) {
                handleSetNewsDetail({
                    ...(newsNext),
                    index: indexNewsNext,
                    disabled_prev: false,
                    disabled_next: false,
                });
                scrollModalBodyToTop();
                setCurrentLang((_prev) => 'ko');
            }
            if (!newsNext) {
                if (Number(queryModal?.page) < Math.ceil(Number(listNews?.total) / Number(queryModal?.limit || 300))) {
                    handleLoadMore();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleDownloaded = (info: any) => {
        if (!!info?.id) {
            setListNews((prev: any) => ({
                list: (prev?.list || []).map((item: any) => {
                    if (String(item?.id) === String(info?.id)) {
                        return ({ ...item, ...info })
                    }
                    return item;
                }),
                total: Number(prev?.total || 0),
            }));
            setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
            dispatch(onGetNewsWeatherWarnings(query));
        }
    };

    const handlePublished = (info: any, is_refresh_category: boolean = false) => {
        if (!!info?.id) {
            setListNews((prev: any) => ({
                list: (prev?.list || []).map((item: any) => {
                    if (String(item?.id) === String(info?.id)) {
                        return ({ ...item, ...info })
                    }
                    return item;
                }),
                total: Number(prev?.total || 0),
            }));
            setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
            dispatch(onGetNewsWeatherWarnings(query));
            if (!!is_refresh_category) {
                handleRefreshCategory();
            }
        }
    };

    const handleUnPublished = (info: any) => {
        if (!!info?.id) {
            setListNews((prev: any) => ({
                list: (prev?.list || []).map((item: any) => {
                    if (String(item?.id) === String(info?.id)) {
                        return ({ ...item, ...info })
                    }
                    return item;
                }),
                total: Number(prev?.total || 0),
            }));
            setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
            dispatch(onGetNewsWeatherWarnings(query));
        }
    };

    const handleCopied = (info: any) => {
        if (!!info?.id) {
            setListNews((prev: any) => ({
                list: (prev?.list || []).map((item: any) => {
                    if (String(item?.id) === String(info?.id)) {
                        return ({ ...item, ...info })
                    }
                    return item;
                }),
                total: Number(prev?.total || 0),
            }));
            setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
            dispatch(onGetNewsWeatherWarnings(query));
        }
    };

    const handleGenerateNews = (info: any) => {
        if (!!info?.id) {
            dispatch(onGetNewsWeatherWarnings(query));
        }
    };


    const [currentLang, setCurrentLang] = useState<string>('ko');
    const handleChangeLang = (_lang: string) => {
        const lang = newsDetail?.translates?.find((tr) => tr?.language_code === _lang);
        setNewsDetail((_prev) => (
            {
                ..._prev,
                title: lang?.title,
                body: lang?.body,
            } as INews
        ));
        setCurrentLang((_prev) => _lang);
    };

    // Begin::Delete
    const handleConfirmDelete = (item: INews) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteMultiNewsV2({
                ids: [initialValuesDefault?.id]
            });
            if (response?.code === 200) {
                dispatch(onGetNewsWeatherWarnings(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    const triggerRefresh = () => {
        dispatch(onGetNewsWeatherWarnings(query));
        setIsOpenImportGenerateBoostingNewsV2((_prev) => false);
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: false,
                thWidth: 100,
                thClass: "align-middle text-center",
                Cell: (cell: any) => (
                    <>

                        <div className="text-center" style={{ minWidth: '80px' }}>
                            <CopyWrapper contentCopy={cell?.value}>
                                {cell?.value}
                            </CopyWrapper>
                        </div>

                    </>
                ),
            },
            // {
            //   Header: t('Type'),
            //   accessor: "type",
            //   filterable: false,
            //   sortable: false,
            //   thClass: "align-middle text-center",
            //   thWidth: i18n?.language === 'en' ? 90 : 80,
            //   Cell: (cell: any) => {
            //     const item: any = cell?.row?.original;
            //     return (
            //       <div style={{ minWidth: '60px' }} className="text-center fs-16">
            //         <span className={`rounded-pill badge bg-${COLORS_KEYWORD_TYPE[`${cell?.value || 0}`] || 'success'}`}>
            //           {KEYWORD_TYPE_OPTIONS_LANG?.find((s: any) => String(s?.value) === String(cell?.value))?.label || ''}
            //         </span>
            //       </div>
            //     );
            //   }
            // },
            // {
            //   Header: t('Media'),
            //   accessor: "media_id",
            //   filterable: true,
            //   sortable: false,
            //   thClass: 'text-start align-middle',
            //   thWidth: 130,
            //   Cell: (cell: any) => {
            //     const item = cell?.row?.original;
            //     return (<>
            //       <div className="text-start hover-underline-primary pe-3" style={{ minWidth: '100px' }}>
            //         <Link
            //           className="nav-link"
            //           target="_blank"
            //           to={item?.news_link || ''} >
            //           {cell?.value || '-'}
            //         </Link>
            //       </div>
            //     </>)
            //   },
            // },
            {
                Header: t('Category'),
                accessor: "category",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '100px' }} className="d-flex flex-column align-items-start gap-2">
                        {(item?.categories || [])?.map((_c: any) => (
                            <span className="rounded-pill badge bg-primary-subtle text-primary fs-13" key={_c?.id}>{_c?.name}</span>
                        ))}
                    </div>)
                },
            },
            {
                Header: t('Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="d-flex justify-content-between align-items-center cursor-pointer ">
                            <Link className='text-normal nav-link  flex-grow-1 hover-underline' to={`https://search.naver.com/search.naver?ssc=tab.news.all&where=news&sm=tab_jum&query=${cell?.value || ''}`} target="_blank" style={{ minWidth: '100px' }}>
                                {cell?.value}
                            </Link>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Article Title'),
                accessor: "articles",
                filterable: true,
                sortable: false,
                thWidth: !newsWeatherWarnings?.list?.length ? 100 : (window.innerWidth < 1650 ? 430 : 770),
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="text-start d-flex flex-column gap-2" style={{ minWidth: '100px' }}
                        >
                            <div key={item?.id} style={{ minWidth: '250px', maxWidth: '730px' }} className="fs-15  d-flex align-items-center" onClick={() => handleShowModalNews([item?.id], item?.id)}>
                                <i className={`ri-checkbox-blank-circle-fill me-1 fs-18 ${!!item?.is_used ? 'text-danger' : 'text-success'} `} style={{ opacity: 0.8 }} />
                                <div className="cursor-pointer hover-underline">
                                    {/* <TooltipCustom
                                        title={t("Article created at")}
                                        className="d-inline-block vertical-align-middle"
                                    >
                                        <span className="text-muted">{item?.created_at_label || ''}</span>
                                    </TooltipCustom>
                                    <span className="text-muted mx-1">|</span> */}
                                    <TooltipCustom
                                        title={t("Article upload at")}
                                        className="d-inline-block vertical-align-middle"
                                    >
                                        <span className="text-muted">{(item?.upload_date || '')?.split(' ')?.[0] || ''}</span>
                                    </TooltipCustom>
                                    <span className="text-muted mx-1">|</span>
                                    <HighlightText text={item?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} />
                                </div>
                                <div className="d-flex align-items-center" style={{ minWidth: '30px', zIndex: 1 }}>
                                    <button className="btn btn-sm text-danger"
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleConfirmDelete(item) }}
                                    ><i className="ri-delete-bin-fill align-bottom"></i></button>
                                </div>
                            </div>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Media'),
                accessor: "media_name",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _media_name = item?.media_name;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_media_name || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Section'),
                accessor: "partner_section_title",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _section = item?.partner_section_title;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_section || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Reporter ID'),
                accessor: "reporter_id",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _reporter_id = item?.reporter_id;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_reporter_id || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Reporter Byline'),
                accessor: "reporter_byline",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _reporter_byline = item?.reporter_byline;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_reporter_byline || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Tag'),
                accessor: "tag",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _tag = item?.tag;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_tag || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 120,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated At'),
                accessor: "updated_at",
                filterable: true,
                sortable: true,
                thWidth: 120,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
                        </div>
                    )
                },
            },

        ],
        [i18n?.language, newsWeatherWarnings?.list?.length, query, partners, userPermissions]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setListNews((prev: any) => ({
            list: [],
            total: 0,
        }));
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy, page: 1 });
        });
    }, []);

    const handleRefreshCategory = async () => {
        try {
            const res1: any = await getAllCategory();
            setListCategory((_prev) => res1?.data || []);
        } catch (error: any) {
            return error;
        }
    };

    const handleCallAllOption = async () => {
        try {
            const [res1, res2, res3]: any = await Promise.all([getAllCategory(), getAllImageCategory({}), getAllPartners({})]);
            setListCategory((_prev) => res1?.data || []);
            setImageCategories((_prev: any) => res2?.data);
            setPartners((_prev: any) => res3?.data);
        } catch (error: any) {
            return error;
        }
    };

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refRight = useRef<any>(null);
    const refStart = useRef<any>(null);
    const [position, setPosition] = useState<any>({ left0: 0, top0: 20, left1: 20, left2: 30, top1: 20, top2: 20 });


    useEffect(() => {
        const getPosition = () => {
            if (refStart.current && modalBodyInnerRef.current && refRight.current) {
                const startRect = refStart.current.getBoundingClientRect();
                const leftRect = modalBodyInnerRef.current.getBoundingClientRect();
                const rightRect = refRight.current.getBoundingClientRect();

                setPosition((_prev: any) => ({ left0: startRect.left, left1: leftRect.left, left2: rightRect.left, top0: startRect.top, top1: leftRect.top, top2: rightRect.top }));
            }
        };

        // Timeout to ensure UI has rendered
        const timeoutId = setTimeout(() => {
            // Get position on mount
            getPosition();
        }, 0);

        // Optionally, track changes on window resize
        window.addEventListener("resize", getPosition);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", getPosition);
        };
    }, [JSON.stringify(newsDetail)]);


    const handleCloseImportGenerateBoostingNewsV2 = () => {
        setIsOpenImportGenerateBoostingNewsV2((_prev) => false);
    };

    const formatAddPreset = useCallback((_data: any | null = null) => {
        if (!_data) return null;
        return ({
            ..._data,
            preset: {
                media_id: _data?.preset?.media_id,
                media_code_id: _data?.preset?.media_code_id,
                media_reporter_id: _data?.preset?.media_reporter_id,
                reporter_byline: _data?.preset?.reporter_byline,
                tag: _data?.preset?.tag,
                // categories: _data?.categories,
                // keyword: _data?.keyword,
            }
        });
    }, []);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_RECOMPOSITION, userPermissions) && (
                    <Col lg={12}>
                        <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                            <Row className="g-4 align-items-center">
                                <div className="col-md-4 col-lg-5 mt-5 mt-sm-4">
                                    <div>
                                        <h5 className="card-title mb-0 d-flex flex-wrap gap-1 gap-xxl-2">
                                            <span>
                                                <span className="me-2">{t('Total')}:</span>
                                                {(isNewsWeatherWarningLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                    start={0}
                                                    end={newsWeatherWarnings?.pagination?.total || 0}
                                                    duration={1}
                                                    className="text-primary"
                                                />)}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                                {/* <div className="col-md-8 col-lg-7 text-end">
                                    {isHavePermissionRole(ROLES_FOR_APP.NEWS_RECOMPOSITION, userPermissions) && (<button
                                        type="button"
                                        className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                        onClick={() => setIsOpenImportGenerateBoostingNewsV2((_prev) => true)}
                                    >
                                        <i className="ri-upload-line align-bottom"></i>
                                        <span className="ms-1">{t('Button Import Bulk Generate Boosting News V2')}</span>
                                    </button>)}
                                    {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_V2, userPermissions) && (<button
                                        type="button"
                                        className="btn btn-primary add-btn rounded-pill ms-2"
                                        onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                                    >
                                        <i className="ri-settings-line align-bottom"></i>
                                        <span className="ms-1">{t('Config Generate')}</span>
                                    </button>)}
                                </div> */}
                            </Row>
                        </CardHeader>
                        <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                            <NestingFilter>
                                <Row className="g-4 align-items-end mt-0">
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Keyword')}...`}
                                                value={keywordSearch}
                                                onChange={(e) => setKeywordSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='mt-3' >
                                        <LabelWrapper label={t('Category')} isShow={true}>
                                            <DropdownOption
                                                name="category"
                                                dataList={(listCategory || [])?.map((_c: any) => ({ label: _c?.name, value: `${_c?.id}` }))}
                                                placeholder={`${t("Category")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={categorySearch || null}
                                                onChangeSelect={(e: any) => setCategorySearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='mt-3' >
                                        <LabelWrapper label={t('Media')} isShow={true}>
                                            <DropdownOption
                                                name="media"
                                                dataList={filterMediaOptions(partners || [])?.map((_p: any) => ({ label: _p?.name, value: `${_p?.id}` }))}
                                                placeholder={`${t("Media")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={mediaSearch || null}
                                                onChangeSelect={(e: any) => setMediaSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                startDate={startDate || null}
                                                endDate={endDate || null}
                                                onChangePicker={handleChangePicker}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-1 order-xxl-0 mt-3 mt-xxl-3'>
                                        <LabelWrapper label={t('Search Media')} isShow={!!mediaSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Search Media')}...`}
                                                value={mediaSearch}
                                                onChange={(e) => setMediaSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col> */}

                                    <Col sm={12} md={12} lg={12} xl={12} xxl={12} className="order-3 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-end justify-content-xl-end justify-content-xxl-end mt-3 mt-xxl-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 me-lg-2"
                                                onClick={searchData}
                                                disabled={isListNewsLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </NestingFilter>
                        </div>
                        <CardBody className="pt-0 px-0">
                            <div className="mx-3 my-4 mt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card "
                                    tableClass="align-middle sticky-table-boosting-news-recomposition"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={newsWeatherWarnings?.list?.length ? newsWeatherWarnings?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={newsWeatherWarnings?.pagination?.total}
                                    customPageCount={Math.ceil(Number(newsWeatherWarnings?.pagination?.total) / Number(query?.limit || 300))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isNewsWeatherWarningLoading}
                                    isShowPagination={true}
                                    isShowLoadingBottom={false}
                                    isScrollToTop={true}
                                />
                            </div>
                        </CardBody>
                    </Col>
                )}
            </Row>
            <ToastContainer closeButton={false} newestOnTop={false} className="toast---------text" pauseOnFocusLoss autoClose={2000} limit={2} />

            <Modal
                isOpen={!!isOpenModalNews}
                centered={true}
                size="xl"
                className={`border-header-footer modal-fullscreen`}
                scrollable={false}
                toggle={handleCloseModalNews}
                keyboard={true}
                innerRef={modalRef}
            >
                <ModalHeader toggle={handleCloseModalNews}>
                    <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            {t('Boosting News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span> {!!newsDetail?.keyword_sub && <> - <span style={{ backgroundColor: '#a8d2fb' }}>{newsDetail?.keyword_sub || ''}</span></>}
                            <ButtonLanguage currentLang={currentLang} handleChangeLang={handleChangeLang} />
                            <span key={newsDetail?.section} className={`rounded-pill me-2 badge bg-primary-subtle text-primary ms-2`}>
                                {newsDetail?.category?.name || ''}
                            </span>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top0,
                        left: position?.left0 + 10,
                        transform: `translateY(-${position?.top0 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('List News')}
                    </span>
                    <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top1,
                        left: position?.left1 + 10,
                        transform: `translateY(-${position?.top1 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('Generated News')}
                    </span>
                    <span className="position-absolute text-primary fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top2,
                        left: position?.left2 + 10,
                        transform: `translateY(-${position?.top2 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {typeShowInfoRight === 'SOURCE' ? t('Source') : t('Google Image')}
                    </span>
                    <div className="h-100-pc w-100 overflow-x-hidden">
                        <Row className="w-100-pc px-0 h-100-pc">
                            <Col lg={3} className="h-100-pc  mt-4 mt-md-0 mb-3 mb-lg-0" >
                                <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('News List')}
                                </span>
                                <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                                    <div className={`box-source-image color-scrollbar-os overflow-x-hidden overflow-y-auto ms-0 ms-lg-3`} ref={refStart} style={{ border: '1.5px dashed var(--vz-success)', width: 'fit-content', minHeight: '80dvh' }}>
                                        <div className="d-flex flex-column gap-3 mt-3 px-1 pb-5">
                                            {(listNews?.list || [])?.map((_n, _idx) => (
                                                <Card className={`position-relative border cursor-pointer  border-hover-success mb-0 ${String(_n?.id) === String(newsDetail?.id) ? 'border-success border-2' : ''}`} key={_n?.id} onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ..._n, index: _idx }) }}>
                                                    <CardBody style={{ position: 'relative' }}>
                                                        <div className="d-sm-flex" >
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex mb-3 justify-content-between align-items-center">
                                                                    <div>
                                                                        {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <></> : <><span className="text-muted fs-13">{t('Total Reviews')}:</span> {formatNumberWithCommas(Number(_n?.source_travel_place?.total_blog_reviews_count) + Number(_n?.source_travel_place?.total_visitor_reviews_count))}</>}
                                                                    </div>
                                                                    <div>
                                                                        <span className={`rounded-pill badge bg-${COLORS_STATUS_NEWS[`${_n?.is_used || 0}`] || 'success'}`}>
                                                                            {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(_n?.is_used))?.label || ''}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <h5 className="">
                                                                    <span className="align-text-top me-1">{!!_n?.is_completed ? <i className='ri-checkbox-line text-success fs-20' /> : <i className='ri-checkbox-indeterminate-line text-danger fs-20' />}</span>
                                                                    <HighlightText text={_n?.title || ''} keyword={_n?.keyword || ''} opacity_bg={0.7} />
                                                                </h5>
                                                                <ul className="list-inline mb-0 d-flex justify-content-between">
                                                                    <li className="list-inline-item">

                                                                    </li>
                                                                    <li className="list-inline-item">
                                                                        {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <><span className="text-muted fs-13">{t('Created at2')}:</span> {_n?.created_at || ''}</> : <><span className="text-muted fs-13">{t('Source Publish Date')}:</span> {_n?.source_publish_time || ''}</>}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                    <span className={`position-absolute text-${String(_n?.id) === String(newsDetail?.id) ? 'success' : 'muted'} fs-13 text-end px-2`} style={{
                                                        top: '-10px',
                                                        left: 5,
                                                        zIndex: 0,
                                                        backgroundColor: 'var(--vz-secondary-bg)'
                                                    }}>
                                                        #{_n?.id}
                                                    </span>
                                                </Card>
                                            ))}
                                        </div>
                                        <div className="text-center my-2 position-absolute" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                            {!!isListNewsLoading && <Spinner size="sm" className="text-success fs-20 align-middle" style={{ width: '30px', height: '30px' }}></Spinner>}
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={6} className="h-100-pc mt-2 mt-md-0">
                                <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('Generated News')}
                                </span>
                                <div ref={modalBodyInnerRef} className="inner-modal-body color-scrollbar-os position-relative p-0 editor-border-radius-0" style={{ border: '1.5px dashed var(--vz-success)' }}>
                                    <BoxGeneratedNews ref={null} newsDetail={newsDetail} imageInsert={imageInsert} voteInsert={voteInsert} isSubKeywordFrequency={false} isShowStatusAndMedia={true} isEdit={false} isShowHighlightText={true} isHighlightDate={true} handleCopied={handleCopied} />
                                </div>
                            </Col>
                            <Col lg={3} className="h-100-pc ms-0 ms-lg-0 pe-3 me-lg-0 mt-4  mt-md-0" >
                                <span className="position-absolute text-primary fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {typeShowInfoRight === 'SOURCE' ? t('Source') : t('Google Image')}
                                </span>
                                {typeShowInfoRight === 'IMAGE' ? <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                                    <div className={`box-source-image overflow-y-hidden overflow-x-hidden px-0 `}>
                                        <BoxImageSearch keyword={newsDetail?.keyword || ''} ref={modalBodyInnerRef} news_id={newsDetail?.id} categories={imageCategories} onSetImageInsert={onSetImageInsert} resetCursorToStart={resetCursorToStart} />
                                    </div>
                                </Row> :
                                    <div className={`row h-100-pc overflow-y-auto color-scrollbar-os align-content-${formatGetSource(newsDetail)?.length === 2 ? 'start' : 'between'} gap-3 gap-lg-${formatGetSource(newsDetail)?.length > 2 ? 2 : 0}`} ref={refRight}>
                                        {formatGetSource(newsDetail)?.length ? formatGetSource(newsDetail)?.map((item: any, index: number) => {
                                            if (!modalSourceInnerRefs.current[index]) {
                                                modalSourceInnerRefs.current[index] = React.createRef<HTMLDivElement>().current;
                                            }
                                            return (
                                                <div ref={(el) => (modalSourceInnerRefs.current[index] = el)} key={index} className={`color-scrollbar-os position-relative box-source-news chill-${formatGetSource(newsDetail)?.length}`}>
                                                    <BoxSourceNews item={item} index={index} keyword={newsDetail?.keyword} keyword_sub={newsDetail?.keyword_sub} session={newsDetail?.section} isSubKeywordFrequency={false} />
                                                </div>
                                            )
                                        }) : <div ref={(el) => (modalSourceInnerRefs.current[0] = el)} style={{ height: '100%' }} className={`color-scrollbar-os position-relative box-source-news chill-1`}>
                                        </div>}
                                    </div>
                                }
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter className="position-relative footer-button-new" lang={i18n?.language || 'en'}>
                    <BoxFooterNews
                        newsDetail={formatAddPreset(newsDetail)}
                        isListNewsLoading={isListNewsLoading}
                        type_page_no_param={query?.type_page_no_param}
                        currentLang={currentLang}
                        isSaving={isSaving}
                        isShowButtonGenerateNews={false}
                        isShowButtonSource={false}
                        isShowSave={false}
                        isShowButtons={true}
                        isShowCategoryOnPublish={true}
                        publishNewsType={PUBLISH_NEWS_TYPE.BOOSTING_NEWS}
                        handlePreviousNews={handlePreviousNews}
                        handleNextNews={handleNextNews}
                        handleDownloaded={handleDownloaded}
                        handlePublished={handlePublished}
                        handleUnPublished={handleUnPublished}
                        handleGenerateNews={handleGenerateNews}
                        onCloseClick={onCloseClick}
                        onSaveClick={onSaveClick}
                        onShowInfoRightClick={onShowInfoRightClick}
                        typeShowInfoRight={typeShowInfoRight}
                        partners={partners}
                        categories={listCategory}
                    />
                </ModalFooter>
            </Modal>


            <ModalImportGenerateBoostingNewsV2
                isOpen={isOpenImportGenerateBoostingNewsV2}
                onRefresh={triggerRefresh}
                onClose={handleCloseImportGenerateBoostingNewsV2}
            />

            <ModalPrompt
                isOpen={isOpenModalConfigPrompt}
                onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
            />

            <ModalConfirm
                header={t('Button Delete')}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />
        </React.Fragment >
    );
};

export default ArticleList;